module.exports = __webpack_public_path__ + "static/media/mwm-LOGO-v1.24421f8b.png";